import styled from 'styled-components';
import { TabPanel, Tabs } from '../../CommonComponents/OPL/Tab';

export const StyledTabs = styled(Tabs)({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  overflowY: 'hidden',
});

export const StyledTabPanel = styled(TabPanel)({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  overflowY: 'hidden',
});
